import type {
  BuiltinVersion,
  CurrentBundleResult,
  DeviceId,
  GetChannelRes,
  LatestVersion,
  PluginVersion,
} from "@capgo/capacitor-updater";
import { create } from "zustand";

export type Resource<T> =
  | { readonly state: "loading"; readonly data?: T }
  | { readonly state: "ready"; readonly data: T }
  | { readonly state: "error"; readonly error: unknown; readonly data?: T };

export type CapgoData = {
  current: Resource<CurrentBundleResult>;
  channel: Resource<GetChannelRes>;
  deviceId: Resource<DeviceId>;
  latest: Resource<LatestVersion>;
  builtinVersion: Resource<BuiltinVersion>;
  pluginVersion: Resource<PluginVersion>;
};

export type Capgo = CapgoData & {
  setCurrent: (value: Resource<CurrentBundleResult>) => void;
  setChannel: (value: Resource<GetChannelRes>) => void;
  setDeviceId: (value: Resource<DeviceId>) => void;
  setLatest: (value: Resource<LatestVersion>) => void;
  setBuiltinVersion: (value: Resource<BuiltinVersion>) => void;
  setPluginVersion: (value: Resource<PluginVersion>) => void;
};

export const useCapgoStore = create<Capgo>((set) => ({
  current: { state: "loading" },
  channel: { state: "loading" },
  deviceId: { state: "loading" },
  latest: { state: "loading" },
  builtinVersion: { state: "loading" },
  pluginVersion: { state: "loading" },
  setCurrent: (value) => set({ current: value }),
  setChannel: (value) => set({ channel: value }),
  setDeviceId: (value) => set({ deviceId: value }),
  setLatest: (value) => set({ latest: value }),
  setBuiltinVersion: (value) => set({ builtinVersion: value }),
  setPluginVersion: (value) => set({ pluginVersion: value }),
}));
